// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-805e1f38]{fill:var(--v-primary-base)}.cls-2[data-v-805e1f38]{fill:#fba346}.cls-3[data-v-805e1f38]{fill:#f6bb93}.cls-4[data-v-805e1f38]{fill:#eab599}.cls-5[data-v-805e1f38]{fill:#f6caae}.cls-6[data-v-805e1f38]{fill:#e1a560}.cls-7[data-v-805e1f38]{fill:#db9d5c}.cls-8[data-v-805e1f38]{fill:#fff3e7}", ""]);
// Exports
module.exports = exports;
